import {defineStore} from "pinia";

// Footnotes (S_Footer): sections add a note ("Prices include VAT", "Based on
// 86 reviews") and get its number back; the footer lists them. A Pinia store
// so each server render has its own. The contract for sections:
//   const n = useFootnotes().add("Prices from, including VAT")  // -> 1
//   <sup>{{ n }}</sup>
export const useFootnotes = defineStore("footnotes", {
    state: () => ({notes: []}),
    actions: {
        add(text) {
            const t = typeof text === "string" ? text.trim() : "";
            if (!t) return null;
            const i = this.notes.indexOf(t);
            if (i >= 0) return i + 1;
            this.notes.push(t);
            return this.notes.length;
        },
        // A new page starts a new list (App.vue calls this before each route).
        clear() {
            this.notes = [];
        },
    },
});
